
import { Component, Emit, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';
import store from "@shared/core/store";

@Component
export default class Navigation extends Vue {
  @Prop({ required: true }) private title!: string;
  @Prop({ required: false }) private backUrl?: string;

  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }
  @Emit('back')
  private goBack() {
    if (this.$listeners['back']) {
      return;
    }
    
    if (this.backUrl) {
      this.$router.push(this.backUrl);
      return;
    }
    this.$router.back();
  }
}
